{
  "pages": {
    "listTitle": "Thanh toán",
    "recordTitle": "Ghi nhận thanh toán",
    "recordPlanAdvanceTitle": "Tạm ứng điều trị",
    "editPlanAdvanceTitle": "Sửa tạm ứng",
    "recordPlanAdvanceRefundTitle": "Hoàn tạm ứng",
    "refundPermissionDenied": "Bạn không có quyền hoàn tạm ứng.",
    "editTitle": "Sửa thanh toán",
    "permissionDenied": "Bạn không có quyền xem thanh toán.",
    "createPermissionDenied": "Bạn không có quyền ghi nhận thanh toán.",
    "updatePermissionDenied": "Bạn không có quyền sửa thanh toán."
  },
  "fields": {
    "code": "Mã",
    "date": "Ngày",
    "patient": "Bệnh nhân",
    "planCode": "Mã kế hoạch",
    "planName": "Tên kế hoạch",
    "method": "Phương thức",
    "amount": "Số tiền",
    "planAmount": "Thanh toán tạm tính",
    "recordedAmount": "Ghi nhận",
    "netCollected": "Thực thu",
    "voucher": "Voucher",
    "clinic": "Phòng khám",
    "notes": "Ghi chú",
    "reference": "Mã giao dịch / tham chiếu",
    "receivedBy": "Người thu",
    "paymentCode": "Mã thanh toán",
    "receiptStatus": "Trạng thái",
    "purpose": "Loại phiếu",
    "cancelReason": "Lý do hủy",
    "cancelledAt": "Thời điểm hủy",
    "receiptCode": "Mã phiếu thu",
    "paymentDate": "Ngày thanh toán",
    "treatmentPlan": "Kế hoạch điều trị",
    "tenders": "Khoản thanh toán",
    "recordedAt": "Thời điểm ghi nhận",
    "lastUpdated": "Cập nhật lần cuối",
    "service": "Dịch vụ",
    "due": "Phải thu",
    "paid": "Đã thu",
    "balance": "Số dư",
    "collect": "Thu lần này"
  },
  "actions": {
    "recordPayment": "Ghi nhận thanh toán",
    "recordPlanAdvance": "Tạm ứng",
    "recordPlanAdvanceRefund": "Hoàn tạm ứng",
    "saving": "Đang lưu...",
    "saveDraft": "Lưu nháp",
    "savingDraft": "Đang lưu nháp...",
    "confirmDraft": "Xác nhận",
    "deleteDraft": "Xóa nháp",
    "update": "Cập nhật",
    "edit": "Sửa",
    "delete": "Xóa",
    "deleting": "Đang xóa...",
    "viewDetails": "Xem chi tiết thanh toán",
    "editPayment": "Sửa thanh toán",
    "cancelPayment": "Hủy phiếu",
    "cancelling": "Đang hủy...",
    "viewTreatmentPlan": "Xem kế hoạch điều trị",
    "viewPatient": "Xem bệnh nhân",
    "fill": "Điền đủ",
    "addTender": "Thêm phương thức",
    "removeTender": "Xóa khoản {{index}}",
    "editAllocation": "Chỉnh phân bổ theo dịch vụ"
  },
  "search": {
    "placeholder": "Tìm theo bệnh nhân, kế hoạch, phương thức hoặc mã tham chiếu..."
  },
  "filters": {
    "trigger": "Bộ lọc",
    "title": "Lọc thanh toán",
    "clearAll": "Xóa tất cả",
    "apply": "Áp dụng",
    "dateRange": "Khoảng thời gian",
    "dateRangePlaceholder": "Chọn khoảng ngày",
    "selectStatus": "Chọn trạng thái",
    "allStatuses": "Tất cả trạng thái",
    "selectPurpose": "Chọn loại phiếu",
    "allPurposes": "Tất cả loại phiếu",
    "selectPatient": "Chọn bệnh nhân",
    "planCodePlaceholder": "Nhập mã kế hoạch",
    "selectMethod": "Chọn phương thức",
    "selectClinic": "Chọn phòng khám",
    "allMethods": "Tất cả phương thức",
    "allClinics": "Tất cả phòng khám"
  },
  "table": {
    "actions": "Thao tác",
    "empty": "Không tìm thấy thanh toán nào.",
    "emptyHistory": "Chưa có thanh toán nào được ghi nhận."
  },
  "details": {
    "title": "Chi tiết thanh toán",
    "receiptNumber": "Phiếu thu {{code}}",
    "paymentCodeLine": "Mã TT {{code}}",
    "closeAria": "Đóng chi tiết thanh toán",
    "allocations": "Phân bổ",
    "serviceAllocations": "Phân bổ dịch vụ",
    "advanceAllocations": "Khoản tạm ứng",
    "planAdvanceAllocation": "Tạm ứng kế hoạch",
    "planAdvanceRefundAllocation": "Hoàn tạm ứng kế hoạch",
    "planDiscount": "Giảm giá kế hoạch",
    "legacyNotItemized": "Thanh toán cũ — chưa phân bổ theo dịch vụ.",
    "netCollectedHero": "Số tiền thực thu",
    "netCollected": "Số tiền thực thu",
    "planAmount": "Số tiền tạm tính",
    "planAmountHint": "Thanh toán tạm tính (trước voucher)",
    "appliedPlanAdvance": "Trừ tạm ứng",
    "settledTotal": "Gạch dịch vụ",
    "cancelBlockedAdvanceHint": "Phiếu đã dùng tiền nộp trước để gạch dịch vụ, không hủy được. Nếu ghi nhầm, dùng quy trình hoàn/điều chỉnh theo phòng khám."
  },
  "receiptStatus": {
    "collected": "Đã thu",
    "draft": "Nháp",
    "cancelled": "Đã hủy"
  },
  "purpose": {
    "service": "Thu điều trị",
    "plan_advance": "Tạm ứng",
    "plan_advance_refund": "Hoàn tạm ứng",
    "wallet_topup": "Nạp TK nạp trước",
    "wallet_refund": "Hoàn TK nạp trước"
  },
  "placeholders": {
    "cancelReason": "Nhập lý do hủy phiếu"
  },
  "dialogs": {
    "editTitle": "Sửa thanh toán",
    "recordTitle": "Ghi nhận thanh toán",
    "cancelTitle": "Hủy phiếu thanh toán",
    "confirmCancel": "Phiếu {{code}} sẽ bị hủy và không còn tính vào số đã thu. Mã phiếu vẫn giữ trên sổ.",
    "deleteDraftTitle": "Xóa phiếu nháp?",
    "deleteDraft": "Phiếu chưa ghi nhận tiền. Xóa thì không hoàn tiền."
  },
  "form": {
    "treatmentPlan": "Kế hoạch điều trị",
    "searchPlanPlaceholder": "Tìm theo mã kế hoạch...",
    "emptyPlans": "Không có kế hoạch điều trị còn số dư. Hãy tạo hoặc cập nhật kế hoạch trước.",
    "emptyPlanAdvances": "Không còn hạn mức tạm ứng trên kế hoạch này.",
    "emptyPlanAdvanceRefunds": "Kế hoạch này không còn tạm ứng chưa gán để hoàn.",
    "refundWalletOnly": "Toàn bộ số hoàn lấy từ tạm ứng đã thu bằng TK nạp trước. Không chi tiền mặt hay chuyển khoản. Lưu để hoàn vào tài khoản nạp trước.",
    "unallocatedPlanAdvance": "Tạm ứng chưa gán",
    "refundAmount": "Số hoàn",
    "refundAmountHint": "Tối đa {{amount}}. Chỉ hoàn phần chưa gạch dịch vụ.",
    "payoutMethod": "Hình thức chi",
    "refundDate": "Ngày hoàn",
    "advanceCoversDue": "Tạm ứng chưa gán đủ cho lần ghi nhận này. Không thu thêm tiền mặt. Lưu để trừ tạm ứng vào dịch vụ.",
    "planAdvanceRequiresConfirmed": "Chưa thể tạm ứng: hãy xác nhận ít nhất một dịch vụ trên kế hoạch trước.",
    "patient": "Bệnh nhân",
    "patientPlaceholder": "Chọn bệnh nhân",
    "planPlaceholder": "Chọn kế hoạch điều trị",
    "dentistName": "BS. {{name}}",
    "planMenuMeta": "{{doctor}} - Còn lại: {{amount}}",
    "changePlanAria": "Đổi kế hoạch điều trị",
    "selectPlanAria": "Chọn kế hoạch điều trị",
    "selectPlanChip": "Chọn kế hoạch",
    "noOtherPlans": "Không còn kế hoạch khác",
    "planMenuDue": "Còn {{due}}",
    "changePlanConfirmTitle": "Đổi kế hoạch điều trị?",
    "changePlanConfirm": "Số tiền, voucher và phân bổ đã nhập sẽ bị xóa. Đổi sang {{code}}?",
    "changePlanConfirmAction": "Đổi kế hoạch",
    "planOption": "{{code}} (còn {{due}})",
    "planOptionWithPatient": "{{patient}} — {{code}} (còn {{due}})",
    "clinicCollect": "Chi nhánh thu tiền",
    "clinicPlaceholder": "Chọn chi nhánh",
    "planBalanceDue": "Số dư kế hoạch còn phải thu:",
    "walletLabel": "TK nạp trước:",
    "walletPrincipal": "gốc",
    "walletBonus": "thưởng",
    "allocateToServices": "Phân bổ theo dịch vụ",
    "allocateAutoHint": "Khi lưu, hệ thống phân bổ tự động theo thứ tự dịch vụ (FIFO). Bật chỉnh tay nếu cần chọn từng dịch vụ.",
    "manualAllocationToggle": "Phân bổ thanh toán thủ công theo dịch vụ",
    "manualAllocationHint": "Tắt = quay về phân bổ tự động theo thứ tự dịch vụ. Bật = chọn từng dịch vụ và số tiền.",
    "multiTenderToggle": "Thanh toán kết hợp nhiều phương thức",
    "multiTenderHint": "Ví dụ tiền mặt + chuyển khoản trong cùng một lần thu.",
    "multiTenderActiveHint": "Đang dùng kết hợp nhiều phương thức thanh toán",
    "collectAmount": "Thanh toán tạm tính",
    "collectAmountHint": "Số tiền dự kiến thanh toán cho kế hoạch này, trước khi áp dụng voucher. Đang phân bổ tự động theo thứ tự dịch vụ.",
    "collectAmountHintManual": "Số tiền dự kiến thanh toán cho kế hoạch này, trước khi áp dụng voucher. Đang phân bổ thủ công — sửa số tiền trong bảng phân bổ bên trái.",
    "customerTendered": "Khách đưa",
    "customerTenderedHelper": "Số tiền khách đưa — thừa sẽ vào TK nạp trước.",
    "customerTenderedOverpayHelper": "{{amount}} sẽ chuyển vào tài khoản nạp trước.",
    "showOptions": "Tùy chọn",
    "hideOptions": "Ẩn tùy chọn",
    "showAdvanced": "Tùy chỉnh (phân bổ, nhiều phương thức, voucher, ghi chú)",
    "hideAdvanced": "Ẩn tùy chỉnh",
    "advancedToggle": "Tùy chỉnh nâng cao",
    "advancedToggleHint": "Ngày thanh toán, phân bổ dịch vụ, nhiều phương thức, voucher, ghi chú",
    "paymentDate": "Ngày thanh toán",
    "paymentMethod": "Phương thức thanh toán",
    "voucherCode": "Mã voucher",
    "voucherPlaceholder": "Nhập mã voucher",
    "voucherChecking": "Đang kiểm tra...",
    "voucherOptional": "Tùy chọn — có thể dùng cùng TK nạp trước / tiền ngoài",
    "voucherPromotion": "Voucher giảm giá",
    "voucherSelectPlaceholder": "Chọn voucher",
    "voucherNone": "Không dùng voucher",
    "voucherPromotionOption": "{{name}} (−{{discount}})",
    "voucherManualToggle": "Nhập mã voucher thủ công",
    "voucherManualHint": "Dùng khi khách mang mã in/SMS cụ thể thay vì chọn voucher giảm giá.",
    "chooseVoucher": "Chọn voucher",
    "voucherSourceList": "Danh sách",
    "voucherSourceCode": "Nhập mã",
    "voucherLockedEdit": "Voucher {{code}} — giảm {{discount}}. Không thể sửa thanh toán có voucher.",
    "walletLockedEdit": "Phiếu thu bằng TK nạp trước không sửa được. Hãy xóa và ghi nhận lại.",
    "amountDue": "Số tiền phải thu:",
    "allocation": "phân bổ",
    "voucher": "voucher",
    "netCollected": "Số tiền thực thu",
    "netCollectedHelper": "Phải bằng số tiền cần thu (không thu thừa trên lần này)",
    "netCollectedMustEqual": "Phải bằng {{amount}} (không thu thừa trên lần này)",
    "allocationAfterVoucher": "Phân bổ {{allocation}} — giảm voucher {{voucher}}",
    "notes": "Ghi chú",
    "notesPlaceholder": "Nhập ghi chú",
    "transactionId": "Mã giao dịch",
    "transactionIdPlaceholder": "Nhập mã giao dịch"
  },
  "methods": {
    "cash": "Tiền mặt",
    "creditCard": "Cà thẻ",
    "debitCard": "Thẻ ghi nợ",
    "bankTransfer": "Chuyển khoản",
    "upi": "UPI",
    "cheque": "Séc",
    "insurance": "Bảo hiểm",
    "wallet": "Tài khoản nạp trước",
    "walletShort": "TK nạp trước",
    "other": "Khác",
    "planAdvanceDraw": "Trừ tạm ứng",
    "mixed": "Hỗn hợp"
  },
  "tenders": {
    "title": "Khoản thanh toán",
    "method": "Phương thức",
    "amount": "Số tiền",
    "ref": "Tham chiếu",
    "optional": "Không bắt buộc",
    "selectMethod": "Chọn phương thức",
    "amountPlaceholder": "Nhập số tiền",
    "total": "Tổng",
    "remaining": "Còn lại {{amount}}",
    "matched": "Đã khớp"
  },
  "planAdvance": {
    "intro": "Tiền thu vào quỹ tạm ứng của kế hoạch, chưa gạch dịch vụ. Không áp dụng voucher hay giảm giá thanh toán.",
    "quotedTotal": "Báo giá kế hoạch",
    "parked": "Tạm ứng chưa gán",
    "headroom": "Còn được tạm ứng",
    "parkedAfter": "Tạm ứng chưa gán sau phiếu",
    "headroomAfter": "Còn được tạm ứng sau phiếu",
    "collectAmount": "Số tiền tạm ứng",
    "fillMax": "Thu tối đa {{amount}}",
    "selectPlanHint": "Chọn kế hoạch điều trị bên dưới."
  },
  "summary": {
    "title": "Nợ kế hoạch: {{amount}}",
    "titleLabel": "Nợ kế hoạch",
    "receiptTitle": "Biên nhận tạm",
    "orderTitle": "Tóm tắt thanh toán",
    "emptyOrder": "Chọn kế hoạch để xem tóm tắt.",
    "planAdvanceHint": "Thu tạm ứng theo hạn mức báo giá của kế hoạch. Cần ít nhất một dịch vụ đã xác nhận hoặc đang điều trị. Số này chưa gạch vào dịch vụ và chưa tính vào Đã thanh toán. Khi Ghi nhận thanh toán, hệ thống trừ tạm ứng chưa gán trước.",
    "planAdvanceRefundHint": "Chỉ hoàn phần tạm ứng chưa gạch dịch vụ. Phiếu thu gốc không đổi. Phần đã thu bằng TK nạp trước được hoàn vào TK nạp trước; phần tiền mặt/chuyển khoản lập phiếu chi theo hình thức bạn chọn.",
    "planAdvanceRefundSplit": "{{wallet}} hoàn vào TK nạp trước, {{cash}} chi tiền mặt hoặc chuyển khoản.",
    "refundTotal": "Số tiền hoàn",
    "serviceFallback": "Dịch vụ",
    "colDescription": "Dịch vụ",
    "colAmount": "Số tiền",
    "subtotal": "Tạm tính",
    "applyPlanAdvance": "Trừ tạm ứng chưa gán",
    "planDiscount": "Giảm giá kế hoạch",
    "planRecorded": "Thanh toán tạm tính",
    "totalDue": "Khách cần trả",
    "planSection": "Theo kế hoạch",
    "planTotal": "Tổng tiền",
    "planPaid": "Đã thu",
    "planRemaining": "Còn lại",
    "planBalance": "Còn nợ kế hoạch",
    "thisPaymentSection": "Thực nhận lần này: {{amount}}",
    "thisPaymentSectionLabel": "Thực nhận lần này",
    "thisPayment": "Số tiền thu",
    "thisPaymentManual": "Lần này thu (chỉnh tay)",
    "recordedThisPayment": "Ghi nhận lần này",
    "customerPaid": "Khách trả",
    "voucher": "Voucher",
    "amountDue": "Cần thu",
    "tenderEntered": "Thực nhận",
    "shortfall": "Còn thiếu",
    "remainingAfter": "Còn nợ sau lần này",
    "tenderBreakdown": "Chi tiết phương thức",
    "walletBalance": "Số dư TK nạp trước: {{amount}}",
    "allocationAutoHint": "Phân bổ tự động theo thứ tự dịch vụ.",
    "allocationManualHint": "Đang phân bổ tay",
    "multiTenderHint": "Nhiều phương thức",
    "statusSelectPlan": "Chọn kế hoạch để bắt đầu thu",
    "statusEnterAmount": "Nhập số tiền ghi nhận",
    "statusShortfall": "Còn thiếu {{amount}}",
    "statusReady": "Đủ tiền — sẵn sàng ghi nhận",
    "statusReview": "Kiểm tra lại trước khi lưu"
  },
  "allocation": {
    "service": "Dịch vụ",
    "due": "Phải thu",
    "paid": "Đã thu",
    "balance": "Số dư",
    "remaining": "Còn nợ",
    "collect": "TT lần này",
    "amountPlaceholder": "Nhập số tiền",
    "selectAll": "Chọn tất cả",
    "unselectAll": "Bỏ chọn tất cả",
    "emptyServices": "Không có dịch vụ phải thu trong kế hoạch này.",
    "applyPlanDiscountOnSettlement": "Giảm giá kế hoạch sẽ được áp dụng khi tất toán",
    "planDiscountSummary": "Giảm giá KH: {{total}} · Đã áp dụng: {{applied}} · Còn lại: {{remaining}}",
    "servicesTotal": "Tổng dịch vụ",
    "planDiscount": "Giảm giá kế hoạch",
    "cashCollected": "Tiền thu được"
  },
  "validation": {
    "invalidVoucher": "Mã voucher không hợp lệ",
    "tenderAmountPositive": "Mỗi khoản thanh toán phải lớn hơn 0",
    "tenderMethodUnique": "Mỗi phương thức thanh toán chỉ được dùng một lần",
    "selectPaymentMethod": "Vui lòng chọn phương thức thanh toán",
    "selectPlan": "Vui lòng chọn kế hoạch điều trị",
    "paymentDateRequired": "Chọn ngày thanh toán",
    "clinicRequired": "Vui lòng chọn chi nhánh",
    "selectServiceOrDiscount": "Chọn ít nhất một dịch vụ hoặc áp dụng giảm giá kế hoạch",
    "allocationPositive": "Tổng phân bổ phải lớn hơn 0",
    "allocationExceeds": "Tổng phân bổ không được vượt quá {{amount}}",
    "tenderMustCover": "Tổng khoản thanh toán phải đủ {{amount}}",
    "tenderMustEqual": "Tổng khoản thanh toán phải bằng {{amount}}",
    "tenderMustEqualAfterVoucher": "Tổng khoản thanh toán phải bằng {{amount}} sau voucher",
    "walletExceedsDue": "Khoản TK nạp trước không được vượt quá số tiền phải thu",
    "walletInsufficient": "Số dư TK nạp trước không đủ. Hiện có: {{amount}}",
    "cashCollectedPositive": "Số tiền thu phải lớn hơn 0",
    "netMustEqualAfterVoucher": "Số tiền thực thu phải bằng {{amount}} sau voucher",
    "netNotLessThanAllocation": "Số tiền thực thu không được nhỏ hơn số phân bổ"
  },
  "toasts": {
    "loadListFailed": "Không tải được danh sách thanh toán",
    "loadListError": "Lỗi khi tải thanh toán. Vui lòng thử lại.",
    "loadPlansFailed": "Không tải được kế hoạch điều trị",
    "loadPlansError": "Không tải được kế hoạch điều trị. Vui lòng thử lại.",
    "loadPlanServicesFailed": "Không tải được dịch vụ của kế hoạch.",
    "loadDetailsFailed": "Không tải được chi tiết thanh toán.",
    "recorded": "Đã ghi nhận thanh toán thành công",
    "refunded": "Đã hoàn tạm ứng",
    "draftSaved": "Đã lưu nháp thanh toán",
    "draftDeleted": "Đã xóa nháp thanh toán",
    "updated": "Đã cập nhật thanh toán thành công",
    "saveFailed": "Lưu thanh toán thất bại",
    "cancelled": "Đã hủy phiếu thanh toán",
    "cancelFailed": "Hủy phiếu thất bại",
    "commissionPeriodLocked": "Không thể sửa hoặc hủy phiếu vì hoa hồng liên quan đã chốt hoặc đã chi. Hãy mở khóa kỳ hoa hồng trước (dòng đã chi không mở khóa được)."
  },
  "errors": {
    "COMMISSION_PERIOD_LOCKED": "Không thể sửa hoặc hủy phiếu vì hoa hồng liên quan đã chốt hoặc đã chi. Hãy mở khóa kỳ hoa hồng trước (dòng đã chi không mở khóa được).",
    "COMMISSION_PERIOD_CLOSED": "Kỳ hoa hồng của tháng này đã đóng. Mở lại kỳ rồi ghi phiếu.",
    "COMMISSION_CLINIC_REQUIRED": "Phiếu thu cần phòng khám để ghi hoa hồng.",
    "PAYMENT_ALREADY_CANCELLED": "Phiếu này đã hủy",
    "PAYMENT_CANCEL_REASON_REQUIRED": "Nhập lý do hủy phiếu",
    "PAYMENT_CANCEL_REASON_TOO_LONG": "Lý do hủy quá dài",
    "PAYMENT_NOTES_TOO_LONG": "Ghi chú quá dài",
    "PLAN_ADVANCE_REQUIRES_CONFIRMED_ITEMS": "Chưa thể tạm ứng: hãy xác nhận ít nhất một dịch vụ trên kế hoạch trước.",
    "VOUCHER_NOT_ALLOWED_ON_PLAN_ADVANCE": "Phiếu tạm ứng không áp dụng voucher hay giảm giá thanh toán.",
    "PLAN_ADVANCE_REFUND_EXCEEDS_PARKED": "Số hoàn vượt tạm ứng chưa gán trên kế hoạch.",
    "PLAN_ADVANCE_HAS_REFUNDS": "Hãy hủy phiếu hoàn tạm ứng trên kế hoạch này trước khi hủy phiếu tạm ứng gốc.",
    "WALLET_DISABLED": "Tổ chức đã tắt tài khoản nạp trước.",
    "PLAN_ADVANCE_DISABLED": "Tổ chức đã tắt tạm ứng theo kế hoạch.",
    "PLAN_ADVANCE_RECEIPT_IN_USE": "Phiếu tạm ứng này đã gạch sang dịch vụ, không hủy được. Nếu ghi nhầm, dùng quy trình hoàn/điều chỉnh theo phòng khám.",
    "PAYMENT_CANCEL_BLOCKED_ADVANCE_APPLIED": "Phiếu này đã trừ tiền nộp trước để gạch dịch vụ, không hủy được. Nếu ghi nhầm, dùng quy trình hoàn/điều chỉnh theo phòng khám.",
    "WALLET_REVERSE_INSUFFICIENT": "Số dư TK nạp trước không còn đủ để đảo khoản đã hoàn vào TK. Hãy nạp lại hoặc hủy giao dịch TK nạp trước sau đó rồi mới hủy phiếu hoàn.",
    "VOUCHER_CODE_TOO_LONG": "Mã voucher quá dài",
    "PAYMENT_CANCELLED": "Phiếu đã hủy, không sửa được",
    "VOUCHER_CODE_USED": "Mã voucher đã được sử dụng",
    "VOUCHER_CODE_UNAVAILABLE_MANUAL": "Mã voucher đã bị khóa",
    "VOUCHER_CODE_UNAVAILABLE_EXPIRED": "Chương trình voucher đã hết hạn",
    "VOUCHER_CODE_UNAVAILABLE_INACTIVE": "Chương trình voucher đã tắt",
    "VOUCHER_CODE_UNAVAILABLE": "Mã voucher không còn sử dụng được"
  },
  "print": {
    "printTooltip": "In phiếu thu",
    "print": "In",
    "downloadTooltip": "Tải PDF",
    "download": "Tải phiếu thu",
    "printAria": "In phiếu thu",
    "downloadAria": "Tải phiếu thu",
    "printFailed": "In phiếu thu thất bại",
    "downloadFailed": "Tải phiếu thu thất bại",
    "downloadSuccess": "Đã tải phiếu thu thành công"
  },
  "pagination": {
    "rowsPerPage": "Số dòng mỗi trang:",
    "displayedRows": "{{from}}–{{to}} / {{count}}",
    "moreThan": "hơn {{to}}"
  },
  "catalog": {
    "pages": {
      "title": "Hình thức thanh toán",
      "permissionDenied": "Bạn không có quyền xem danh mục hình thức thanh toán."
    },
    "actions": {
      "add": "Thêm hình thức",
      "edit": "Chỉnh sửa",
      "deactivate": "Ngừng dùng",
      "reactivate": "Bật lại",
      "history": "Lịch sử"
    },
    "fields": {
      "name": "Tên",
      "code": "Mã",
      "icon": "Biểu tượng",
      "sortOrder": "Thứ tự",
      "type": "Loại",
      "status": "Trạng thái"
    },
    "icons": {
      "cash": "Tiền mặt",
      "bank": "Ngân hàng",
      "card": "Thẻ",
      "wallet": "Tài khoản nạp trước",
      "ewallet": "Ví điện tử",
      "qr": "QR / UPI",
      "insurance": "Bảo hiểm",
      "cheque": "Séc",
      "other": "Khác"
    },
    "type": {
      "system": "Hệ thống",
      "custom": "Tùy chỉnh"
    },
    "status": {
      "active": "Đang dùng",
      "inactive": "Ngừng dùng"
    },
    "search": {
      "placeholder": "Tìm theo tên hoặc mã..."
    },
    "table": {
      "empty": "Chưa có hình thức thanh toán",
      "noFound": "Không tìm thấy hình thức thanh toán",
      "createdAt": "Ngày tạo",
      "updatedAt": "Ngày sửa",
      "createdBy": "Người tạo",
      "updatedBy": "Người cập nhật"
    },
    "history": {
      "title": "Lịch sử hình thức thanh toán",
      "empty": "Chưa có thay đổi nào trên mục này."
    },
    "dialogs": {
      "addTitle": "Thêm hình thức thanh toán",
      "editTitle": "Chỉnh sửa hình thức thanh toán"
    },
    "placeholders": {
      "name": "Ví dụ: Chuyển khoản",
      "sortOrder": "Ví dụ: 1"
    },
    "validation": {
      "nameRequired": "Vui lòng nhập tên hình thức thanh toán",
      "nameTooLong": "Tên không quá {{max}} ký tự",
      "sortOrderInvalid": "Thứ tự phải là số từ 0 đến 999999"
    },
    "toasts": {
      "created": "Đã thêm hình thức thanh toán",
      "updated": "Đã cập nhật hình thức thanh toán",
      "deactivated": "Đã ngừng dùng hình thức thanh toán",
      "reactivated": "Đã bật lại hình thức thanh toán",
      "saveFailed": "Không lưu được hình thức thanh toán",
      "deactivateFailed": "Không ngừng dùng được hình thức thanh toán",
      "loadFailed": "Không tải được danh mục hình thức thanh toán"
    },
    "moreMethods": "Phương thức khác",
    "moreMethodsShort": "Khác",
    "chooseOtherMethod": "Chọn phương thức khác"
  }
}
